import React from 'react';

interface HeaderProps {
    handleCancel?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const Header: React.FC<HeaderProps> = ({ handleCancel }) => {
    return (
        <>
            <div className="relative m-4">
              { handleCancel && <button className="absolute top-0 left-0 locator-button" onClick={ handleCancel }>
                <img src="./icons/close.svg" alt="Close" className="w-5" />
              </button>}
              <img src="./logo-automaticffl.png" alt="Automatic FFL" className="w-32 mx-auto" />
            </div>
            <div className="text-center px-4">
              <p className="font-bold text-primary text-2xl">FIND YOUR DEALER</p>
              <span>Use the options below to search for a dealer near you.</span>
            </div>
        </>
    );
};

export default Header;